import getCategoriesProducts from '@services/menu/getCategoriesProducts';
import { SHELVES_SECTIONS_MAX_QUANTITY } from '@shopDetails/constants';

// get initial categories to fetch his products
const getCategoriesIds = sections => {
  if (sections?.length >= SHELVES_SECTIONS_MAX_QUANTITY) {
    return sections.slice(0, SHELVES_SECTIONS_MAX_QUANTITY);
  }

  return sections && sections.slice(0, sections.lenght);
};

// merge two arrays an remove duplicates searching by a especific property
export function mergeArraysAndRemoveDuplicates(arr1, arr2, property) {
  if (!arr1 || !arr2 || !property) {
    return [];
  }
  const mergedArray = [...arr1, ...arr2];
  const map = new Map();

  mergedArray.forEach(obj => {
    const key = obj[property];
    if (!map.has(key)) {
      map.set(key, obj);
    }
  });

  return Array.from(map.values());
}

// get category tree products
export async function fetchCategoryTreeProducts({ categories, axios, shop }) {
  const menu = {};
  const categoriesToGetProducts = getCategoriesIds(categories);
  // eslint-disable-next-line camelcase
  const request = categoriesToGetProducts.map(({ globalId }) =>
    getCategoriesProducts({
      axios,
      shopId: shop.id,
      categoryId: globalId,
    }),
  );

  const prods = await Promise.allSettled(request);
  const fulfilledProducts = prods?.filter(p => p.status === 'fulfilled');

  const categoriesWithProducts = fulfilledProducts.map(category => {
    const categoryId = Object.keys(category?.value?.data)?.[0];

    const result = categories.find(c => c.globalId === categoryId);
    const products = category?.value?.data[categoryId]?.items || [];
    return { ...result, products };
  });

  menu.sections = mergeArraysAndRemoveDuplicates(
    categoriesWithProducts,
    categories,
    'id',
  );

  menu.total = categories?.length;
  menu.offset = 0;
  menu.count = 20;
  menu.max = 20;
  return menu;
}

// get the category tree and flatten it
export const flattenCategories = array =>
  array?.reduce((categories, item) => {
    if (Array.isArray(item?.children)) {
      return [...categories, ...flattenCategories(item.children)];
    }
    if (item) {
      // eslint-disable-next-line camelcase
      const { global_id, ...categoryWithoitSnakeProperties } = item;
      return [
        ...categories,
        { ...categoryWithoitSnakeProperties, globalId: global_id },
      ];
    }
    return categories;
  }, []);

// this method iterate over the category tree and get the first child of each category
export const flattenMenuGridCategories = category => {
  if (category?.children && category?.children?.length > 0) {
    const firstChild = category.children[0];

    // eslint-disable-next-line camelcase
    const { global_id, ...rest } = category;
    delete rest.children;
    return {
      id: firstChild.global_id,
      ...rest,
      globalId: global_id,
    };
  }
  return null;
};
